// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Studio Component */
.studio-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 1rem;
  /* Extra padding at bottom allows scrolling prompt to top of viewport during recording */
  padding-bottom: 70vh;
}

.studio-prompt-display {
  background: var(--color-card-bg);
  padding: 1.5rem 2rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  border: 2px solid var(--color-primary);
  font-size: 1.75rem;
  line-height: 1.6;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-weight: bold;
  color: var(--color-text);
}

/* Inspired-by attribution for friend-suggested prompts */
.studio-prompt-attribution {
  margin-top: 0.75rem;
  font-size: 0.8rem;
  font-weight: 400;
  color: var(--color-primary, #3b82f6);
  opacity: 0.85;
  letter-spacing: 0.01em;
}

/* Title row - between prompt and mode selector */
.studio-title-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  max-height: 50px;
  opacity: 1;
  overflow: hidden;
  transition: max-height 1.5s ease-in-out,
              margin 1.5s ease-in-out,
              opacity 1.5s ease-in-out;
}

.studio-title-row.collapsed {
  max-height: 0;
  margin: 0;
  opacity: 0;
}

.studio-title-label {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--color-text-on-background, #ffffff);
  flex-shrink: 0;
}

.studio-title-input {
  flex: 1 1;
  background: #fff;
  border: 1px solid var(--color-border);
  border-radius: 0.25rem;
  padding: 0.4rem 0.5rem;
  font-size: 1.1rem;
  color: var(--color-text);
  font-family: inherit;
  outline: none;
}

.studio-title-input:focus {
  border-color: var(--color-primary);
}

.studio-title-input::placeholder {
  color: var(--color-text-muted);
  font-style: italic;
}

.studio-title-row.readonly {
  background: #fff;
  border-radius: 0.25rem;
  padding: 0.4rem 0.5rem;
}

.studio-title-row.readonly .studio-title-label {
  font-size: 1.1rem;
  font-weight: 700;
  color: #000;
}

.studio-title-display {
  flex: 1 1;
  font-size: 1.1rem;
  color: #000;
}

.studio-title-refresh-btn {
  background: none;
  border: 1px solid var(--color-text-on-background, #ffffff);
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--color-text-on-background, #ffffff);
  font-size: 1rem;
  transition: all 0.2s;
  flex-shrink: 0;
}

.studio-title-refresh-btn:hover:not(:disabled) {
  border-color: var(--color-primary);
  color: var(--color-primary);
}

.studio-title-refresh-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.studio-mode-selector {
  max-width: 24rem;
  margin: 0 auto 1.5rem;
  background: var(--color-card-bg);
  border-radius: 9999px;
  display: flex;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* Animation properties for collapse/expand */
  max-height: 100px;
  opacity: 1;
  transition: max-height 1.5s ease-in-out,
              margin 1.5s ease-in-out,
              opacity 1.5s ease-in-out,
              padding 1.5s ease-in-out;
}

.studio-mode-selector.collapsed {
  max-height: 0;
  margin: 0 auto;
  opacity: 0;
  padding: 0;
}

.studio-mode-btn {
  flex: 1 1;
  padding: 0.6rem 0.75rem;
  background: var(--color-card-bg);
  color: var(--color-text-secondary);
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.2s;
}

.studio-mode-btn.active {
  background: var(--color-active-bg);
  color: var(--color-active-text);
}

.studio-mode-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.studio-recording-area {
  position: relative;
  background: var(--color-card-bg);
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
  min-height: 350px;
  display: flex;
  flex-direction: column;
}

/* Text section fills remaining space inside recording area */
.studio-recording-area > .reflection-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  border: none;
}

.studio-recording-area > .reflection-section > .reflection-section-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.studio-recording-area > .reflection-section > .reflection-section-content .quill {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.studio-recording-area > .reflection-section > .reflection-section-content .ql-container {
  flex: 1 1;
}

/* Save Changes button inside recording area */
.studio-save-changes-btn {
  margin-top: 1rem;
  padding: 0.6rem 1.5rem;
  border-radius: 9999px;
  border: none;
  background: var(--color-primary);
  color: #fff;
  font-weight: 500;
  font-size: 0.95rem;
  cursor: pointer;
  align-self: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s;
}

.studio-save-changes-btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Video container inside recording area - maintains consistent height */
.studio-recording-area video {
  min-height: 300px;
  background: #000;
}

.studio-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
}

.studio-back-btn {
  padding: 0.75rem 2rem;
  border-radius: 9999px;
  border: none;
  background: var(--color-card-bg);
  color: var(--color-text);
  font-weight: 500;
  font-size: 1rem;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s;
}

.studio-back-btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.studio-status {
  text-align: center;
  color: var(--color-text-secondary);
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.studio-error {
  text-align: center;
  color: var(--color-error, #e74c3c);
  padding: 1rem;
}

.studio-playback-actions {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 1rem;
}

.studio-action-btn {
  padding: 0.5rem 1.5rem;
  border-radius: 9999px;
  border: none;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.studio-rerecord-btn {
  background: var(--color-active-bg);
  color: var(--color-active-text);
}

.studio-rerecord-btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.studio-delete-btn {
  background: var(--color-card-bg);
  color: var(--color-error, #e74c3c);
}

.studio-delete-btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.studio-transcribe-btn {
  background: var(--color-primary);
  color: #fff;
}

.studio-transcribe-btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.studio-transcribe-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Follow-up context (shown when responding to an enhancement question) */
/* Follow-up ancestor chain */
.studio-chain {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;
}

.studio-chain-connector {
  width: 2px;
  height: 1.25rem;
  background: var(--color-border);
}

.studio-chain-node {
  border-radius: 0.5rem;
  text-align: center;
  line-height: 1.5;
  width: 100%;
  max-width: 600px;
}

/* Prompt at top: small, themed with white text */
.studio-chain-prompt {
  background: var(--color-primary);
  color: #fff;
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  border: 1px solid var(--color-primary-hover);
}

/* Ancestor follow-up questions: small, themed with white text */
.studio-chain-ancestor {
  background: var(--color-primary);
  color: #fff;
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  font-style: italic;
  border: 1px solid var(--color-primary-hover);
}

/* Current question being answered: large, prominent white box */
.studio-chain-current {
  background: var(--color-card-bg);
  padding: 1.5rem 2rem;
  font-size: 1.75rem;
  font-weight: bold;
  border: 2px solid var(--color-primary);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.studio-chain-current.wide {
  max-width: 900px;
}

/* Enhancement section */
.studio-enhance-section {
  margin-top: 1.5rem;
  padding: 1rem;
  background: var(--color-card-bg);
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.studio-enhance-btn {
  background: var(--color-primary);
  color: #fff;
  display: block;
  margin: 0 auto;
}

.studio-enhance-btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}


.studio-reenhance-confirm {
  margin-top: 0.75rem;
  padding: 0.75rem;
  background: var(--color-surface);
  border-radius: 0.5rem;
  border: 1px solid var(--color-border);
}

.studio-reenhance-confirm p {
  margin: 0 0 0.75rem;
  font-size: 0.9rem;
  color: var(--color-text-secondary);
}

.studio-reenhance-actions {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
}

.studio-suggestions-panel {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.studio-suggestion {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background: var(--color-surface);
  border-radius: 0.5rem;
  border: 1px solid var(--color-border);
  gap: 0.75rem;
}

.studio-suggestion.answered {
  opacity: 0.7;
  border-style: dashed;
}

.studio-suggestion-text {
  flex: 1 1;
  font-size: 0.9rem;
  line-height: 1.4;
}

.studio-suggestion-respond-btn {
  background: var(--color-active-bg);
  color: var(--color-active-text);
  white-space: nowrap;
  flex-shrink: 0;
}

.suggestion-answered-badge {
  font-size: 0.8rem;
  color: var(--color-success, #27ae60);
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Unsaved changes dialog */
.studio-unsaved-dialog {
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 1rem;
  padding: 2rem;
  max-width: 440px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.studio-unsaved-dialog h2 {
  color: var(--color-text-primary);
  margin: 0 0 0.75rem;
  font-size: 1.3rem;
}

.studio-unsaved-dialog p {
  color: var(--color-text-secondary);
  margin: 0 0 1.5rem;
  line-height: 1.5;
}

.studio-unsaved-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}

.studio-unsaved-btn {
  padding: 0.6rem 1.25rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 0.95rem;
  transition: all 0.2s;
}

.studio-unsaved-btn-cancel {
  background: rgba(231, 76, 60, 0.15);
  color: rgba(231, 76, 60, 0.7);
}

.studio-unsaved-btn-discard {
  background: var(--color-danger, #e74c3c);
  color: #fff;
}

.studio-unsaved-btn-save {
  background: var(--color-primary);
  color: #fff;
  font-weight: 600;
}

/* Storage warning banner */
.studio-storage-warning {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fbbf24;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  text-align: center;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/Studio/Studio.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,wFAAwF;EACxF,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,yDAAyD;AACzD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB;;sCAEoC;AACtC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qCAAqC;EACrC,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,0DAA0D;EAC1D,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+CAA+C;EAC/C,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,6CAA6C;EAC7C,iBAAiB;EACjB,UAAU;EACV;;;sCAGoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,gCAAgC;EAChC,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,wCAAwC;EACxC,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,6DAA6D;AAC7D;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,wEAAwE;AACxE;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,gCAAgC;EAChC,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,gEAAgE;AAChE;EACE,gCAAgC;EAChC,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,gEAAgE;AAChE;EACE,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;EAChC,qBAAqB;EACrB,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* Studio Component */\n.studio-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 1rem;\n  /* Extra padding at bottom allows scrolling prompt to top of viewport during recording */\n  padding-bottom: 70vh;\n}\n\n.studio-prompt-display {\n  background: var(--color-card-bg);\n  padding: 1.5rem 2rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  border: 2px solid var(--color-primary);\n  font-size: 1.75rem;\n  line-height: 1.6;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  font-weight: bold;\n  color: var(--color-text);\n}\n\n/* Inspired-by attribution for friend-suggested prompts */\n.studio-prompt-attribution {\n  margin-top: 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 400;\n  color: var(--color-primary, #3b82f6);\n  opacity: 0.85;\n  letter-spacing: 0.01em;\n}\n\n/* Title row - between prompt and mode selector */\n.studio-title-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  max-height: 50px;\n  opacity: 1;\n  overflow: hidden;\n  transition: max-height 1.5s ease-in-out,\n              margin 1.5s ease-in-out,\n              opacity 1.5s ease-in-out;\n}\n\n.studio-title-row.collapsed {\n  max-height: 0;\n  margin: 0;\n  opacity: 0;\n}\n\n.studio-title-label {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--color-text-on-background, #ffffff);\n  flex-shrink: 0;\n}\n\n.studio-title-input {\n  flex: 1;\n  background: #fff;\n  border: 1px solid var(--color-border);\n  border-radius: 0.25rem;\n  padding: 0.4rem 0.5rem;\n  font-size: 1.1rem;\n  color: var(--color-text);\n  font-family: inherit;\n  outline: none;\n}\n\n.studio-title-input:focus {\n  border-color: var(--color-primary);\n}\n\n.studio-title-input::placeholder {\n  color: var(--color-text-muted);\n  font-style: italic;\n}\n\n.studio-title-row.readonly {\n  background: #fff;\n  border-radius: 0.25rem;\n  padding: 0.4rem 0.5rem;\n}\n\n.studio-title-row.readonly .studio-title-label {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #000;\n}\n\n.studio-title-display {\n  flex: 1;\n  font-size: 1.1rem;\n  color: #000;\n}\n\n.studio-title-refresh-btn {\n  background: none;\n  border: 1px solid var(--color-text-on-background, #ffffff);\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--color-text-on-background, #ffffff);\n  font-size: 1rem;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.studio-title-refresh-btn:hover:not(:disabled) {\n  border-color: var(--color-primary);\n  color: var(--color-primary);\n}\n\n.studio-title-refresh-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.studio-mode-selector {\n  max-width: 24rem;\n  margin: 0 auto 1.5rem;\n  background: var(--color-card-bg);\n  border-radius: 9999px;\n  display: flex;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  /* Animation properties for collapse/expand */\n  max-height: 100px;\n  opacity: 1;\n  transition: max-height 1.5s ease-in-out,\n              margin 1.5s ease-in-out,\n              opacity 1.5s ease-in-out,\n              padding 1.5s ease-in-out;\n}\n\n.studio-mode-selector.collapsed {\n  max-height: 0;\n  margin: 0 auto;\n  opacity: 0;\n  padding: 0;\n}\n\n.studio-mode-btn {\n  flex: 1;\n  padding: 0.6rem 0.75rem;\n  background: var(--color-card-bg);\n  color: var(--color-text-secondary);\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 1rem;\n  transition: all 0.2s;\n}\n\n.studio-mode-btn.active {\n  background: var(--color-active-bg);\n  color: var(--color-active-text);\n}\n\n.studio-mode-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.studio-recording-area {\n  position: relative;\n  background: var(--color-card-bg);\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1.5rem;\n  min-height: 350px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Text section fills remaining space inside recording area */\n.studio-recording-area > .reflection-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n  border: none;\n}\n\n.studio-recording-area > .reflection-section > .reflection-section-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n}\n\n.studio-recording-area > .reflection-section > .reflection-section-content .quill {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.studio-recording-area > .reflection-section > .reflection-section-content .ql-container {\n  flex: 1;\n}\n\n/* Save Changes button inside recording area */\n.studio-save-changes-btn {\n  margin-top: 1rem;\n  padding: 0.6rem 1.5rem;\n  border-radius: 9999px;\n  border: none;\n  background: var(--color-primary);\n  color: #fff;\n  font-weight: 500;\n  font-size: 0.95rem;\n  cursor: pointer;\n  align-self: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s;\n}\n\n.studio-save-changes-btn:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n/* Video container inside recording area - maintains consistent height */\n.studio-recording-area video {\n  min-height: 300px;\n  background: #000;\n}\n\n.studio-actions {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.studio-back-btn {\n  padding: 0.75rem 2rem;\n  border-radius: 9999px;\n  border: none;\n  background: var(--color-card-bg);\n  color: var(--color-text);\n  font-weight: 500;\n  font-size: 1rem;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s;\n}\n\n.studio-back-btn:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.studio-status {\n  text-align: center;\n  color: var(--color-text-secondary);\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n}\n\n.studio-error {\n  text-align: center;\n  color: var(--color-error, #e74c3c);\n  padding: 1rem;\n}\n\n.studio-playback-actions {\n  display: flex;\n  justify-content: center;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.studio-action-btn {\n  padding: 0.5rem 1.5rem;\n  border-radius: 9999px;\n  border: none;\n  font-weight: 500;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.studio-rerecord-btn {\n  background: var(--color-active-bg);\n  color: var(--color-active-text);\n}\n\n.studio-rerecord-btn:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.studio-delete-btn {\n  background: var(--color-card-bg);\n  color: var(--color-error, #e74c3c);\n}\n\n.studio-delete-btn:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.studio-transcribe-btn {\n  background: var(--color-primary);\n  color: #fff;\n}\n\n.studio-transcribe-btn:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.studio-transcribe-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Follow-up context (shown when responding to an enhancement question) */\n/* Follow-up ancestor chain */\n.studio-chain {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.studio-chain-connector {\n  width: 2px;\n  height: 1.25rem;\n  background: var(--color-border);\n}\n\n.studio-chain-node {\n  border-radius: 0.5rem;\n  text-align: center;\n  line-height: 1.5;\n  width: 100%;\n  max-width: 600px;\n}\n\n/* Prompt at top: small, themed with white text */\n.studio-chain-prompt {\n  background: var(--color-primary);\n  color: #fff;\n  padding: 0.5rem 1rem;\n  font-size: 0.85rem;\n  border: 1px solid var(--color-primary-hover);\n}\n\n/* Ancestor follow-up questions: small, themed with white text */\n.studio-chain-ancestor {\n  background: var(--color-primary);\n  color: #fff;\n  padding: 0.5rem 1rem;\n  font-size: 0.85rem;\n  font-style: italic;\n  border: 1px solid var(--color-primary-hover);\n}\n\n/* Current question being answered: large, prominent white box */\n.studio-chain-current {\n  background: var(--color-card-bg);\n  padding: 1.5rem 2rem;\n  font-size: 1.75rem;\n  font-weight: bold;\n  border: 2px solid var(--color-primary);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.studio-chain-current.wide {\n  max-width: 900px;\n}\n\n/* Enhancement section */\n.studio-enhance-section {\n  margin-top: 1.5rem;\n  padding: 1rem;\n  background: var(--color-card-bg);\n  border-radius: 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.studio-enhance-btn {\n  background: var(--color-primary);\n  color: #fff;\n  display: block;\n  margin: 0 auto;\n}\n\n.studio-enhance-btn:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n\n.studio-reenhance-confirm {\n  margin-top: 0.75rem;\n  padding: 0.75rem;\n  background: var(--color-surface);\n  border-radius: 0.5rem;\n  border: 1px solid var(--color-border);\n}\n\n.studio-reenhance-confirm p {\n  margin: 0 0 0.75rem;\n  font-size: 0.9rem;\n  color: var(--color-text-secondary);\n}\n\n.studio-reenhance-actions {\n  display: flex;\n  justify-content: center;\n  gap: 0.75rem;\n}\n\n.studio-suggestions-panel {\n  margin-top: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.studio-suggestion {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1rem;\n  background: var(--color-surface);\n  border-radius: 0.5rem;\n  border: 1px solid var(--color-border);\n  gap: 0.75rem;\n}\n\n.studio-suggestion.answered {\n  opacity: 0.7;\n  border-style: dashed;\n}\n\n.studio-suggestion-text {\n  flex: 1;\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n.studio-suggestion-respond-btn {\n  background: var(--color-active-bg);\n  color: var(--color-active-text);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.suggestion-answered-badge {\n  font-size: 0.8rem;\n  color: var(--color-success, #27ae60);\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* Unsaved changes dialog */\n.studio-unsaved-dialog {\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 1rem;\n  padding: 2rem;\n  max-width: 440px;\n  width: 90%;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.studio-unsaved-dialog h2 {\n  color: var(--color-text-primary);\n  margin: 0 0 0.75rem;\n  font-size: 1.3rem;\n}\n\n.studio-unsaved-dialog p {\n  color: var(--color-text-secondary);\n  margin: 0 0 1.5rem;\n  line-height: 1.5;\n}\n\n.studio-unsaved-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\n.studio-unsaved-btn {\n  padding: 0.6rem 1.25rem;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-size: 0.95rem;\n  transition: all 0.2s;\n}\n\n.studio-unsaved-btn-cancel {\n  background: rgba(231, 76, 60, 0.15);\n  color: rgba(231, 76, 60, 0.7);\n}\n\n.studio-unsaved-btn-discard {\n  background: var(--color-danger, #e74c3c);\n  color: #fff;\n}\n\n.studio-unsaved-btn-save {\n  background: var(--color-primary);\n  color: #fff;\n  font-weight: 600;\n}\n\n/* Storage warning banner */\n.studio-storage-warning {\n  background: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fbbf24;\n  border-radius: 0.5rem;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n  text-align: center;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
